import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { LoaderXs } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useBoardStore } from 'src/features/boards';

import { TaskEdit } from '../../../tasks';
import { useAgileStore } from '../..//store';
import { deleteEpic } from '../../api/useAgileService';
import { SprintTable } from '../table/SprintTable';

export const AgileEpics = () => {
  const [isTaskOpen, setTaskOpen] = useState(false);
  const [isDeletePromptOpen, setIsDeletePromptOpen] = useState<boolean>(false);

  const router = useRouter();
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;
  const id = router?.query?.slug;
  const { epics, fetchBacklogsAndSprints, setFileId, isLoading, setLoading, fetchEpics, setItem } =
    useAgileStore();
  const filters = useBoardStore((s) => s.filters);

  useEffect(() => {
    const getAgileData = async () => {
      setLoading(true);
      setFileId(id as string);
      Promise.all([fetchBacklogsAndSprints(id as string), fetchEpics(id as string)]).finally(() => {
        setLoading(false);
      });
    };
    getAgileData();
  }, [filters]);

  useEffect(() => {
    if (router?.query?.taskId) {
      setTaskOpen(true);
    } else {
      setTaskOpen(false);
    }
  }, [router]);

  const handleTaskViewClose = () => {
    const link = `/${mode}/${orgId}/files/${id}?view=${id}&type=${router.query.type}`;
    router.push(link);
  };

  const onToggleDeletePrompt =
    (isOpen = true) =>
    () => {
      setIsDeletePromptOpen(isOpen);
    };

  const handleDeleteTask = async () => {
    await deleteEpic(router?.query?.taskId as string);
    handleTaskViewClose();
    await Promise.all([fetchBacklogsAndSprints(id as string), fetchEpics(id as string)]);
    setIsDeletePromptOpen(false);
  };

  return (
    <>
      {isLoading ? (
        <>
          <div className="h-screen w-full mt-48">
            <div className="overflow-hidden">
              <LoaderXs className="mx-auto text-xss" />
            </div>
          </div>
        </>
      ) : (
        <div className=" bg-gray-100">
          <div className="mx-auto py-16 pl-30 mobile:px-16 desktop:px-24 bigScreen:px-64 pt-6 bg-gray-100">
            <div>
              <div>
                <SprintTable
                  sprint={{
                    _id: 'epics',
                    items: epics,
                    title: 'Epics',
                    totalStoryPoints: epics.reduce((acc, curr) => acc + (curr.storyPoint || 0), 0),
                    description: '',
                    board: '',
                    isSprintRunning: 0,
                  }}
                />
              </div>
            </div>
          </div>
          <Modal onClose={handleTaskViewClose} isOpen={isTaskOpen} motionPreset="none">
            <ModalOverlay />
            <ModalContent
              style={{
                position: 'initial',
                maxWidth: '118rem',
              }}
              className={`${'min-w-768 h-vh90'} bg-white rounded-lg static`}
            >
              <TaskEdit
                id={router?.query?.taskId as string}
                onDelete={onToggleDeletePrompt(true)}
                type="scrum"
                onChangeTask={(e) => {
                  if (!e.task.isSubtask && e.task.column && e.task.id) {
                    setItem(e.task, e.task.id);
                  }
                }}
              />
            </ModalContent>
          </Modal>
          <Modal
            isOpen={isDeletePromptOpen}
            onClose={() => {
              setIsDeletePromptOpen(false);
            }}
          >
            <ModalOverlay />

            <ModalContent
              style={{
                maxWidth: '46rem',
                padding: '32px',
                marginTop: '20rem',
                borderRadius: '8px',
              }}
            >
              <ModalCloseButton />
              <p className="mb-32 text-md text-gray-999">Are you sure you wish to proceed?</p>
              <div className="flex justify-end">
                <button
                  onClick={() => {
                    setIsDeletePromptOpen(false);
                  }}
                  className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
                >
                  Cancel
                </button>
                <button
                  className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
                  onClick={handleDeleteTask}
                >
                  Delete
                </button>
              </div>
            </ModalContent>
          </Modal>
        </div>
      )}
    </>
  );
};
